// extracted by mini-css-extract-plugin
export default {"errorNoticeContainer":"error-notice_errorNoticeContainer__BuM08","warning":"error-notice_warning__r0xH9"};